import { jsonToGraphQLQuery, EnumType } from 'json-to-graphql-query';
import axiosObj from './config';
import { handleQuery } from '../utils/request'

const NOTIFICATION_API_URL = `${process.env.API_URL}/notification/graphql`;

const DEFAULT_ACTOR_FIELDS = {
  id: true,
  firstName: true,
  lastName: true,
};

const DEFAULT_NOTIFICATIONS_FIELDS = {
  unreadCount: true,
  count: true,
  notificationList: {
    _id: true,
    category: true,
    message: true,
    readState: true,
    actor: DEFAULT_ACTOR_FIELDS,
    resourceId: true,
    createdAt: true,
  },
};

const DEFAULT_NOTIFICATIONS_SETTINGS_FIELDS = {
  aiModel: true,
  application: true,
  billing: true,
  dashboard: true,
  device: true,
  module: true,
  profile: true,
  user: true,
  video: true,
  dataset: true,
  deviceOffline: true,
  report: true,
  location: true
};

const isWorkspaceSelectionPage = () => window.location?.pathname?.includes('/workspace/select')

const hasActiveWorkspace = () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}')
    return Boolean(userData.activeWorkspace)
  } catch (error) {
    return false
  }
}

const shouldSkipNotificationRequest = () => isWorkspaceSelectionPage() || !hasActiveWorkspace()

const getNotificationsFallbackResponse = () => ({
  data: {
    data: {
      notifications: {
        unreadCount: 0,
        count: 0,
        notificationList: [],
      },
    },
  },
})

const getNotificationSettingsFallbackResponse = () => ({
  data: {
    data: {
      notificationSettings: {},
    },
  },
})

const getNotificationPermissionsFallbackResponse = () => ({
  data: {
    data: {
      notificationPermissions: {},
    },
  },
})

export function getNotificationPermissions(params) {
  if (shouldSkipNotificationRequest()) {
    return Promise.resolve(getNotificationPermissionsFallbackResponse())
  }

  const query = {
    query: {
      notificationPermissions: {
        __args: params
      }
    }
  }
  return handleQuery(query, NOTIFICATION_API_URL)
}

export function updateNotificationPermissions(param) {
  const query = {
    mutation: {
      updateNotificationPermissions: {
        __args: param
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function getNotifications(param) {
  if (shouldSkipNotificationRequest()) {
    return Promise.resolve(getNotificationsFallbackResponse())
  }

  const args = {
    ...(param || {}),
    sort: param?.sort || {
      field: 'createdAt',
      type: new EnumType('DESC'),
    },
  }

  const query = {
    query: {
      notifications: {
        __args: args,
        ...DEFAULT_NOTIFICATIONS_FIELDS,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function getNotificationSettings() {
  if (shouldSkipNotificationRequest()) {
    return Promise.resolve(getNotificationSettingsFallbackResponse())
  }

  const query = {
    query: {
      notificationSettings: {
        ...DEFAULT_NOTIFICATIONS_SETTINGS_FIELDS,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function updateNotificationSettings(param) {
  const query = {
    mutation: {
      updateNotificationSettings: {
        __args: param,
        ...DEFAULT_NOTIFICATIONS_SETTINGS_FIELDS,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function deleteAllNotifications(param) {
  const query = {
    mutation: {
      deleteAllNotifications: {
        __args: param,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}


export function deleteNotification(param) {
  const query = {
    mutation: {
      deleteNotification: {
        __args: param,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}


export function readAllNotifications(param) {
  const query = {
    mutation: {
      readAllNotifications: {
        __args: param,
        ...DEFAULT_NOTIFICATIONS_FIELDS,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function readNotification(param) {
  const query = {
    mutation: {
      readNotification: {
        __args: param,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}


export function unreadAllNotifications(param) {
  const query = {
    mutation: {
      unreadAllNotifications: {
        __args: param,
        ...DEFAULT_NOTIFICATIONS_FIELDS,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}

export function unreadNotification(param) {
  const query = {
    mutation: {
      unreadNotification: {
        __args: param,
      },
    },
  };

  return handleQuery(query, NOTIFICATION_API_URL)
}
